import {management} from '../../../../index'
import {FarmsDapRepository} from "../../../infra/knex/repositories/farmsDapRepository"
import {LogSectorRepository} from "../../../infra/knex/repositories/log_sector"

import {GetManagementFarmDapUseCase} from "./getManagementFarmDAP"


export const managementFarmDapUseCase=()=>{
  const logSectorRepository= new LogSectorRepository(management)
  const farmsDapRepository= new FarmsDapRepository(management)

  const showFarmByIdUseCase=new GetManagementFarmDapUseCase(farmsDapRepository,logSectorRepository)
  return showFarmByIdUseCase
}
